// src/Regions.tsx
import PropTypes2 from "prop-types";

// src/Region.tsx
import PropTypes from "prop-types";

// src/ComponentTag.ts
var ComponentTag_default = (component) => component && component.path ? `						
							<!--# COMPONENT ${component.path} -->` : null;

// src/Region.tsx
import { jsx } from "react/jsx-runtime";
var Region = ({
  name,
  regionData,
  tag,
  addClass
}) => {
  if (!(name || "").trim()) {
    console.error(`<Region NO_NAME> name: ${JSON.stringify(name)}`);
    throw Error(`Can't render <Region> without a 'name' prop.`);
  }
  if (!regionData || typeof regionData !== "object" || !Object.keys(regionData).length) {
    console.error(`<Region "${name}"> regionData: ${JSON.stringify(regionData)}`);
    throw Error(`Can't render <Region "${name}"> without a 'regionData' prop.`);
  }
  const TAG = tag || "div";
  return /* @__PURE__ */ jsx(
    TAG,
    {
      "data-portal-region": name,
      className: "xp-region" + (addClass ? ` ${addClass}` : ""),
      dangerouslySetInnerHTML: {
        __html: `					${regionData.components && regionData.components.length > 0 ? regionData.components.map((component) => ComponentTag_default(component)).join("\n") : ""}					
`
      }
    }
  );
};
Region.propTypes = {
  name: PropTypes.string.isRequired,
  regionData: PropTypes.shape({
    components: PropTypes.arrayOf(PropTypes.shape({
      path: PropTypes.string.isRequired
    }))
  }).isRequired,
  tag: PropTypes.string,
  addClass: PropTypes.string
};
var Region_default = Region;

// src/Regions.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var Regions = ({
  regionsData,
  names,
  tags,
  classes
}) => {
  if (!regionsData || typeof regionsData !== "object") {
    console.error("<Regions> regions: " + JSON.stringify(regionsData));
    throw Error("Can't render <Regions> without a 'regionsData' prop.");
  }
  const selectedRegions = !names ? Object.keys(regionsData) : typeof names === "string" ? [names] : Array.isArray(names) ? names : null;
  if (!selectedRegions) {
    console.error("<Regions> names: " + JSON.stringify(names));
    throw Error("Can't render <Regions>: 'names' prop must be a string, an array of strings or omitted/falsy.");
  }
  return selectedRegions.map(
    (name) => (
      //@ts-ignore
      /* @__PURE__ */ jsx2(
        Region_default,
        {
          regionData: regionsData[name],
          name,
          tag: typeof tags === "string" ? tags : (tags || {})[name],
          addClass: classes === true ? name : typeof classes === "string" ? classes : (classes || {})[name]
        },
        name
      )
    )
  );
};
Regions.propTypes = {
  regionsData: PropTypes2.objectOf(
    PropTypes2.shape({
      components: PropTypes2.arrayOf(
        PropTypes2.shape({
          path: PropTypes2.string.isRequired
        })
      )
    })
  ).isRequired,
  names: PropTypes2.oneOfType([
    PropTypes2.string,
    PropTypes2.arrayOf(
      PropTypes2.string
    )
  ]),
  tags: PropTypes2.oneOfType([
    PropTypes2.string,
    PropTypes2.objectOf(
      PropTypes2.string
    )
  ]),
  classes: PropTypes2.oneOfType([
    PropTypes2.bool,
    PropTypes2.string,
    PropTypes2.objectOf(
      PropTypes2.string
    )
  ])
};
var Regions_default = Regions;
export {
  Regions_default as default
};
